import {Dispatch} from "redux";

import {createRequestActionTypes} from "@pg-mono/request-state";

import {addSuccessNotification} from "../../notifications/utils/add_success_notification";
import {IApplication} from "../types/IApplication";
import {alertFormSuccessMessage} from "../utils/alert_text";

const APPLICATION_PREFIX = `desktop/application/CREATE`;
export const applicationCreateTypes = createRequestActionTypes(APPLICATION_PREFIX);

export const afterPostApplicationActions = (storeHash: string, applicationResponse: IApplication) => (dispatch: Dispatch) => {
    if (applicationResponse) {
        // dispatching applicationCreateTypes.success makes sense because we store application response in redux - this can possibly be moved to ApplicationModalArray local state
        dispatch({type: applicationCreateTypes.success, id: storeHash, result: applicationResponse});

        dispatch(addSuccessNotification(alertFormSuccessMessage));
    }
};
export const resetApplicationPost = (id: string) => ({type: applicationCreateTypes.reset, id});
import {Dispatch} from "redux";

import {createRequestActionTypes} from "@pg-mono/request-state";

import {addSuccessNotification} from "../../notifications/utils/add_success_notification";
import {IApplication} from "../types/IApplication";
import {alertFormSuccessMessage} from "../utils/alert_text";

const APPLICATION_PREFIX = `desktop/application/CREATE`;
export const applicationCreateTypes = createRequestActionTypes(APPLICATION_PREFIX);

export const afterPostApplicationActions = (storeHash: string, applicationResponse: IApplication) => (dispatch: Dispatch) => {
    if (applicationResponse) {
        // dispatching applicationCreateTypes.success makes sense because we store application response in redux - this can possibly be moved to ApplicationModalArray local state
        dispatch({type: applicationCreateTypes.success, id: storeHash, result: applicationResponse});

        dispatch(addSuccessNotification(alertFormSuccessMessage));
    }
};
export const resetApplicationPost = (id: string) => ({type: applicationCreateTypes.reset, id});
